import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/hr/attendance')({
  component: AttendanceLayout,
})

function AttendanceLayout() {
  return (
    <ModuleGuard moduleKey="hr">
      <Outlet />
    </ModuleGuard>
  )
}
